import { Package, Smile, Cog, Users } from "lucide-react";

export const highlights = [
  { 
    value: "250+", 
    label: "Products", 
    icon: Package 
  },
  { 
    value: "750+", 
    label: "Satisfied Clients", 
    icon: Smile 
  },
  { 
    value: "10+", 
    label: "EU & Japanese standard machines", 
    icon: Cog 
  },
  { 
    value: "650+", 
    label: "Channel Partners", 
    icon: Users 
  },
];
